import React from "react";
import styled from 'styled-components'
import { HubUserProvider } from "./HubspotContext";

const Wrap = styled.div``

const AppWrapper = ({ children }) => {
  return (
    <Wrap>
      {/* <HubUserProvider 
      // asUser={76351} // Kennan
      > */}
        {children}
      {/* </HubUserProvider> */}
    </Wrap>
  );
};

export default AppWrapper;
